import { Chip, Tooltip, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../utils/dateFormatter";
import { getUserIdentifier } from "../utils/avatarUtils";
import {
  getClassificationBadgeSx,
  getClassificationLabelKey,
  getClassificationValue,
} from "../utils/complaintClassification";

const ComplaintClassificationChip = ({
  ticket,
  interactive = false,
  displayOnly = false,
  size = "small",
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const classification = getClassificationValue(ticket);
  const label = t(getClassificationLabelKey(classification));
  const badgeSx = getClassificationBadgeSx(classification, theme);

  const classifiedBy = ticket?.complaint_classification?.classified_by;
  const classifiedAt = ticket?.complaint_classification?.classified_at;
  const classifierName = getUserIdentifier(classifiedBy);

  const chip = (
    <Chip
      label={label}
      size={size}
      sx={{
        ...badgeSx,
        fontWeight: 600,
        cursor: displayOnly ? "default" : undefined,
        pointerEvents: displayOnly ? "none" : undefined,
      }}
    />
  );

  if (!interactive || displayOnly || !classifierName || !classifiedAt) {
    return chip;
  }

  const tooltipTitle = `${classifierName} — ${formatDate(classifiedAt)}`;

  return (
    <Tooltip title={tooltipTitle} arrow enterTouchDelay={0}>
      {chip}
    </Tooltip>
  );
};

export default ComplaintClassificationChip;
